import styled from 'styled-components';
import {TextField} from '@mui/material';

const StyledTextArea = styled(TextField)``;

export {StyledTextArea};
